import { jwtDecode } from "jwt-decode";

export const jwt = {
  decode: jwtDecode
};
